import React from 'react'
import { useHistory } from 'react-router-dom'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Form, Row, Col, Button } from '_zari/core'

import { CodigosTransaccionesConstant } from 'constants/index'

import { ZrSwal } from 'utils'

import * as PromocionesService from 'services/promocion.service'

import * as FormGroups from './formGroups'

const MainForm = ({ editarData }) => {
  const __zariContext = React.useContext(ZariContext)

  const history = useHistory()

  const formikRef = React.useRef(null)

  const formInitialValues = React.useMemo(() => {
    return {
      _idProductoOrigen: editarData._idProductoOrigen ?? '',
      _idProductoPresentacionOrigen: editarData._idProductoPresentacionOrigen ?? '',
      _idProductoPresentacionPromocion: editarData._idProductoPresentacionPromocion ?? '',
      _idProductoPromocion: editarData._idProductoPromocion ?? '',
      factor: editarData.factor ?? 1,
      cantidadActivacion: editarData.cantidadActivacion ?? 1,
      fechaFin: editarData.fechaFin ?? '',
      fechaInicio: editarData.fechaInicio ?? '',
      flagPaso2: editarData._id ? true : false,
      nombreProductoOrigen: editarData.nombreProductoOrigen ?? '',
      nombreProductoPromocion: editarData.nombreProductoPromocion ?? '',
      porcentajeDescuentoPromocion: editarData.porcentajeDescuentoPromocion ?? '',
      unidadMedidaOrigen: editarData.unidadMedidaOrigen ?? '',
      unidadMedidaPromocion: editarData.unidadMedidaPromocion ?? ''
    }
  }, [editarData])

  const clickVerificarPromocionExistente = React.useCallback(
    _idProductoPresentacionOrigen => {
      if (!_idProductoPresentacionOrigen) {
        __zariContext.snack('error', 'Seleccionar producto origen.')
        return
      }

      PromocionesService.obtenerxIdProductoPresentacionOrigenAsIdPromocion(_idProductoPresentacionOrigen)
        .then(({ data }) => {
          if (data && data.hash) {
            ZrSwal.showAlert({
              mensaje: 'Se ha detectado una promoción asignada al producto, desea continuar?',
              tipo: 'warning',
              showCerrar: true,
              onSuccess: () => {
                history.push(`/${CodigosTransaccionesConstant.PROMOCIONES_NUEVOACTUALIZAR}/${data.hash}`)
              }
            })
          } else {
            formikRef.current.setFieldValue('flagPaso2', true)
          }
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext, history]
  )

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      __zariContext.loader.open('Guardando promoción.')

      const funcionEjecutar = editarData._id
        ? () => PromocionesService.actualizarxId(editarData._id, data)
        : () => PromocionesService.nuevo(data)

      funcionEjecutar()
        .then(() => {
          __zariContext.toast('success', 'El registro se ha guardado.')
          history.push(`/${CodigosTransaccionesConstant.PROMOCIONES_LISTA}`)
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setSubmitting(false)
        })
        .finally(() => {
          __zariContext.loader.close()
        })
    },
    [__zariContext, history, editarData._id]
  )

  return (
    <Row>
      <Col md={6}>
        <Formik innerRef={formikRef} initialValues={formInitialValues} onSubmit={onSubmit}>
          {({ errors, touched, isSubmitting, values, handleSubmit, setValues }) => (
            <Form>
              <Row>
                <Col md={6}>
                  <FormGroups.ProductoOrigenFormGroup
                    fIsSubmitting={isSubmitting}
                    iError={errors._idProductoPresentacionOrigen}
                    setValues={setValues}
                    values={values}
                    iValue={values._idProductoPresentacionOrigen}
                  />
                </Col>
                {!values.flagPaso2 && (
                  <Col md={6}>
                    <Button
                      tiny
                      outline
                      onClick={() => clickVerificarPromocionExistente(values._idProductoPresentacionOrigen)}
                      disabled={isSubmitting || !values._idProductoPresentacionOrigen}
                    >
                      Gestionar promoción
                    </Button>
                  </Col>
                )}
              </Row>
              {values.flagPaso2 && (
                <Row>
                  <Col md={6}>
                    <FormGroups.FechaInicioFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.fechaInicio}
                      iTouched={touched.fechaInicio}
                    />
                    <FormGroups.FechaFinFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.fechaFin}
                      iTouched={touched.fechaFin}
                    />
                    <FormGroups.ProductoPromocionFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors._idProductoPresentacionPromocion}
                      setValues={setValues}
                      values={values}
                      iValue={values._idProductoPresentacionPromocion}
                    />
                    <FormGroups.CantidadActivacionFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.cantidadActivacion}
                      iTouched={touched.cantidadActivacion}
                    />
                    <FormGroups.FactorFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.factor}
                      iTouched={touched.factor}
                    />
                    <FormGroups.PorcentajeDescuentoPromocionFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.porcentajeDescuentoPromocion}
                      iTouched={touched.porcentajeDescuentoPromocion}
                    />
                    <Row>
                      <Col md={12} className='text-right'>
                        <Button tiny onClick={handleSubmit} disabled={isSubmitting}>
                          Procesar
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Form>
          )}
        </Formik>
      </Col>
    </Row>
  )
}

export default React.memo(MainForm)
